export default __webpack_public_path__ + "static/media/expandArrow.07447756.svg";